/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Success_AgainInputs */

const en_contact_success_again = /** @type {(inputs: Contact_Success_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send another message`)
};

/**
* | output |
* | --- |
* | "Send another message" |
*
* @param {Contact_Success_AgainInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const contact_success_again = /** @type {((inputs?: Contact_Success_AgainInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Success_AgainInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_contact_success_again(inputs)
});